/**
 * KraftStories — Klaviyo "Added to Cart" tracking
 *
 * Klaviyo's Shopify integration does NOT track Added to Cart automatically;
 * this snippet feeds the metric so Abandoned Cart / Browse Abandonment flows
 * can trigger. It mirrors the add-to-cart detection in analytics-events.js:
 *   1. `theme:cart:add`  — dispatched by product-form-drawer.js with the
 *      /cart/add.js JSON response in event.detail.data
 *   2. `cart:update`     — module-based add path (product-form-component /
 *      quick-add), deduped against #1 with a 1s window
 *
 * Events only record for profiles Klaviyo has identified (subscribers,
 * past customers, popup signups) — anonymous visitors are skipped by
 * Klaviyo itself. Payload follows Klaviyo's standard Added to Cart schema.
 */
(function () {
  'use strict';

  var lastTrackedAt = 0;

  function track(payload) {
    // window.klaviyo is the async queue provided by the Klaviyo onsite embed
    window.klaviyo = window.klaviyo || [];
    window.klaviyo.push(['track', 'Added to Cart', payload]);
  }

  function money(cents) {
    return Math.round((cents || 0)) / 100;
  }

  function lineToItem(line) {
    return {
      ProductID: String(line.product_id || ''),
      SKU: line.sku || '',
      ProductName: line.product_title || line.title || '',
      Quantity: line.quantity || 1,
      ItemPrice: money(line.final_price || line.price),
      RowTotal: money(line.final_line_price || line.line_price),
      ProductURL: line.url ? (window.location.origin + line.url) : '',
      ImageURL: line.image || '',
      ProductCategories: line.product_type ? [line.product_type] : [],
    };
  }

  /**
   * added: single line item object from /cart/add.js (or cart line)
   * Fetches the full cart for context, then fires the Klaviyo event.
   */
  function trackAddedItem(added) {
    if (!added) return;
    lastTrackedAt = Date.now();

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart.items || []).map(lineToItem);
        track({
          $value: money(cart.total_price),
          AddedItemProductName: added.product_title || added.title || '',
          AddedItemProductID: String(added.product_id || ''),
          AddedItemSKU: added.sku || '',
          AddedItemPrice: money(added.final_price || added.price),
          AddedItemQuantity: added.quantity || 1,
          AddedItemURL: added.url ? (window.location.origin + added.url) : '',
          AddedItemImageURL: added.image || '',
          AddedItemCategories: added.product_type ? [added.product_type] : [],
          ItemNames: items.map(function (i) { return i.ProductName; }),
          Items: items,
          CheckoutURL: window.location.origin + '/checkout',
        });
      })
      .catch(function () { /* never break the storefront */ });
  }

  // Path 1: theme drawer add (event.detail.data = /cart/add.js response)
  document.addEventListener('theme:cart:add', function (event) {
    var data = event.detail && event.detail.data;
    if (!data) return;
    if (Array.isArray(data.items)) {
      data.items.forEach(trackAddedItem);
    } else {
      trackAddedItem(data);
    }
  });

  // Path 2: module-based add (cart:update), deduped against path 1
  document.addEventListener('cart:update', function (event) {
    var detail = event.detail || {};
    var data = detail.data || {};
    if (data.didError) return;
    if (data.source !== 'product-form-component' && data.source !== 'quick-add') return;
    if (Date.now() - lastTrackedAt < 1000) return;

    var variantId = String(detail.sourceId || data.variantId || '');

    setTimeout(function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart.items || !cart.items.length) return;
          var addedLine = cart.items.find(function (item) {
            return String(item.variant_id || '') === variantId;
          }) || cart.items[0];
          trackAddedItem(addedLine);
        })
        .catch(function () {});
    }, 250);
  });
}());
